import { lighten, makeStyles } from '@material-ui/core/styles';
import { styles as containerStyles } from '../styles/container';
import { MAP_BREAKPOINT } from './variables';

const useStyles = makeStyles((theme) => ({
  container: containerStyles(theme),
  heroRoot: {
    width: '100%',
    padding: theme.spacing(5, 0),
  },
  heroWrapper: {
    backgroundColor: theme.props.background.primary,
    width: '100%',
    textAlign: 'center',
    position: 'relative',
    padding: theme.spacing(4, 0, 8),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4, 0, 15),
    },
  },
  heroBox: {
    width: '100%',
    margin: 'auto',
    position: 'relative',
  },
  heroMainBox: {
    width: '100%',
    maxWidth: 860,
    margin: 'auto',
    '& img': {
      width: '80%',
      height: 'auto',
      maxWidth: 445,
    },
  },
  heroGrid: {
    position: 'absolute',
    zIndex: 30,
    bottom: -35,
    [theme.breakpoints.up('sm')]: {
      bottom: -80,
    },
  },
  heroFirstGrid: {
    width: '100%',
    maxWidth: 860,
    position: 'relative',
    zIndex: 20,
    padding: theme.spacing(0, 1),
  },
  heroLeftImg: {
    width: '50%',
    maxWidth: 195,
    height: 'auto',
  },
  heroRightImg: {
    width: '50%',
    maxWidth: 185,
    height: 'auto',
    position: 'relative',
    bottom: -8,
  },
  heroJointGrid: {
    position: 'absolute',
    left: 0,
    right: 0,
    zIndex: 10,
    bottom: -2,
    [theme.breakpoints.up('sm')]: {
      bottom: 6,
    },
    '& img': {
      width: '100%',
      height: 'auto',
    },
  },
  highlight: {
    position: 'relative',
    display: 'flex',
    justifyContent: 'center',
    '& img.highlight': {
      width: 20,
      height: 'auto',
      position: 'absolute',
      top: -10,
      left: -15,
    },
  },
  bgSecondary: {
    backgroundColor: theme.props.background.secondary,
  },
  innerContainer: {
    ...containerStyles(theme),
    paddingRight: '0 !important',
    paddingLeft: '0 !important',
  },
  areaMapBox: {
    width: '100%',
    maxWidth: 470,
    height: 'auto',
    position: 'relative',
    margin: theme.spacing(9, 'auto', 6),
    '& img.map': {
      width: '100%',
      height: 'auto',
      display: 'none',
      [theme.breakpoints.up(MAP_BREAKPOINT)]: {
        display: 'block',
      },
    },
  },
  areaProduct: {
    [theme.breakpoints.up(MAP_BREAKPOINT)]: {
      position: 'absolute',
      top: 0,
      left: -140,
    },
  },
  areaOsaki: {
    position: 'relative',
    marginBottom: theme.spacing(3),
    [theme.breakpoints.up(MAP_BREAKPOINT)]: {
      position: 'absolute',
      left: 0,
      bottom: 200,
      marginBottom: 0,
    },
  },
  areaDivider: {
    borderBottom: `2px dotted ${theme.props.border.primary}`,
    width: '100%',
  },
  areaIntro: {
    backgroundColor: theme.props.background.third,
    padding: theme.spacing(4, 2),
    position: 'relative',
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(4, 5),
      '& > *:first-child': {
        marginRight: theme.spacing(4),
      },
    },
    '&:after': {
      position: 'absolute',
      content: '""',
      width: 0,
      height: 0,
      borderLeft: '20px solid transparent',
      borderRight: '20px solid transparent',
      borderTop: `20px solid ${theme.props.background.third}`,
      bottom: -12,
      right: 0,
      left: 0,
      margin: 'auto',
    },
  },
  plans: {
    padding: theme.spacing(5, 0),
  },
  business: {
    border: `1px solid ${theme.props.border.primary}`,
    borderRadius: theme.shape.borderRadius,
    display: 'flex',
    alignItems: 'center',
    padding: '16px 15px',
    backgroundColor: theme.palette.common.white,
    '&:hover, &:focus': {
      color: theme.palette.text.primary,
    },
  },
  businessImage: {
    width: 60,
    height: 60,
  },
  businessName: {
    margin: theme.spacing(0, 2),
  },
  businessArrow: {
    marginLeft: 'auto',
    color: theme.palette.text.primary,
  },
  flowGrid: {
    display: 'flex',
    flexDirection: 'column-reverse',
    [theme.breakpoints.up('sm')]: {
      flexDirection: 'row',
      '& > *:first-child': {
        paddingRight: theme.spacing(4),
      },
    },
  },
  announcementButton: {
    backgroundColor: theme.props.palette.secondary.main,
    color: theme.palette.common.white,
    position: 'relative',
    '&:hover, &:focus': {
      backgroundColor: lighten(theme.props.palette.secondary.main, 0.15),
      color: theme.palette.common.white,
    },
    '& .wrapper': {
      position: 'relative',
      left: -25,
      fontWeight: 'bold',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'center',
    },
    '& img.mask': {
      width: '100%',
      height: 'auto',
      maxWidth: 60,
      marginRight: theme.spacing(1),
    },
  },
  flowImageGrid: {
    backgroundColor: theme.props.background.primary,
    textAlign: 'center',
    padding: `${theme.spacing(4, 2)} !important`,
    '& img': {
      width: '100%',
      height: 'auto',
      maxWidth: 580,
    },
    [theme.breakpoints.up('sm')]: {
      display: 'flex',
      '& img': {
        margin: 'auto',
      },
    },
  },
  titleBox: {
    border: `2px solid ${theme.props.border.primary}`,
    display: 'flex',
    flexDirection: 'column',
    position: 'relative',
    padding: theme.spacing(3, 2),
    [theme.breakpoints.up('sm')]: {
      padding: theme.spacing(5),
    },
    '& .title': {
      margin: theme.spacing(0, 'auto'),
      padding: theme.spacing(0, 4),
      backgroundColor: theme.palette.common.white,
      position: 'relative',
      top: theme.spacing(-3) - 20,
      [theme.breakpoints.up('sm')]: {
        top: theme.spacing(-5) - 20,
      },
    },
    '&:not(:last-of-type)': {
      marginBottom: theme.spacing(6.5),
    },
  },
}));

export default useStyles;
